import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { showBrandFollowToast } from "@faire/retailer-visitor-shared/features/RetailerBoards/Components/BrandFollowToast";
import { getRetailerToken } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import deleteFollowsBrand from "@faire/web-api--source/api/v2/retailers/retailerToken/follows/brandToken/delete";
import postFollowsBrand from "@faire/web-api--source/api/v2/retailers/retailerToken/follows/brandToken/post";
export var followBrand = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(brandToken, brandName) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        postFollowsBrand(getRetailerToken(), brandToken)
                    ];
                case 1:
                    _state.sent();
                    showBrandFollowToast(brandName);
                    return [
                        2
                    ];
            }
        });
    });
    return function followBrand(brandToken, brandName) {
        return _ref.apply(this, arguments);
    };
}();
export var unFollowBrand = function(brandToken) {
    deleteFollowsBrand(getRetailerToken(), brandToken);
};
export var trackBoardsEvent = function(eventName) {
    trackEvent("retailer/".concat(getRetailerToken(), "/boards/").concat(eventName));
};
